module.exports = __webpack_public_path__ + "static/media/BroomeAdvertiser-socshare-min.81a443fd.jpg";